import { render, staticRenderFns } from "./MisTable.vue?vue&type=template&id=68ecafc0"
import script from "./MisTable.vue?vue&type=script&lang=js"
export * from "./MisTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports